module.exports = __webpack_public_path__ + "static/media/carp_mobile_booking_reporting.8f96a7bf.gif";